import { RecordByPrimaryKey } from "@pdfking/templates"

import type { Processing } from "#internal"

// Mirrors Python `print_colors` in `objects/processing/library.py`. "CMYK"/"BN"
// are literal; the rest are translation keys (see i18n/entities).
export const ProcessingList = RecordByPrimaryKey<Processing>([
  { id: "cmyk", name: "CMYK" },
  { id: "cmykv", name: "CMYK_VARNISH" },
  { id: "cmyk1", name: "CMYK_1_PANTONE" },
  { id: "cmyk2", name: "CMYK_2_PANTONES" },
  { id: "bn", name: "BN" },
  { id: "p1", name: "ONE_PANTONE" },
  { id: "p2", name: "TWO_PANTONES" },
] as const)
